import { render, staticRenderFns } from "./AddUpdateAutoCompetencies.vue?vue&type=template&id=6fb1b130&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AddUpdateAutoCompetencies.vue?vue&type=script&lang=js"
export * from "./AddUpdateAutoCompetencies.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateAutoCompetencies.vue?vue&type=style&index=0&id=6fb1b130&prod&scoped=true&lang=css"
import style1 from "./AddUpdateAutoCompetencies.vue?vue&type=style&index=1&id=6fb1b130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1b130",
  null
  
)

export default component.exports